export default __webpack_public_path__ + "assets/icons/search-left.19931370.svg";